import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { MantineProvider } from '@mantine/core';
import { DatesProvider } from '@mantine/dates';
import { Notifications } from '@mantine/notifications';
import { DEFAULT_THEME_COLOR, normalizeThemeColor } from '../config/themeColors';
import { createJlfcTheme } from '../theme';
import { setAccentColor } from '../lib/jlfcTheme';
import ConfirmDialogProvider from '../components/ConfirmDialogProvider';

const ThemeColorContext = createContext({
  themeColor: DEFAULT_THEME_COLOR,
  setThemeColor: () => {},
});

export function useThemeColor() {
  return useContext(ThemeColorContext);
}

export default function JlfcThemeProvider({ themeColor: themeColorProp, children }) {
  const [themeColor, setThemeColor] = useState(() => normalizeThemeColor(themeColorProp));

  useEffect(() => {
    setThemeColor(normalizeThemeColor(themeColorProp));
  }, [themeColorProp]);

  useEffect(() => {
    setAccentColor(themeColor);
  }, [themeColor]);

  const theme = useMemo(() => createJlfcTheme(themeColor), [themeColor]);

  return (
    <ThemeColorContext.Provider value={{ themeColor, setThemeColor }}>
      <MantineProvider theme={theme} defaultColorScheme="light">
        <DatesProvider settings={{ locale: 'fr', firstDayOfWeek: 1 }}>
          <ConfirmDialogProvider>
            <Notifications position="top-right" zIndex={5000} />
            {children}
          </ConfirmDialogProvider>
        </DatesProvider>
      </MantineProvider>
    </ThemeColorContext.Provider>
  );
}
